import React, { useState, useMemo } from 'react'
import { observer } from 'mobx-react'
import {
    TagsDropdownContainer,
    TagsDropdownHeader,
    TagsDropdownBody,
    TagOption,
    TagCheckbox,
    TagIcon,
    TagLabel
} from './TagsDropdown.styles'
import { SmartTagIcon } from '../../VaultMetadataPanel/MetadataLabelsSection/TagsTagCategory/SmartTagIcon'
import { CheckboxCheckmarkIcon } from './icons'
import { DropdownSearch } from './DropdownSearch'
import { useStore } from '../../../../app/data/root.store'
import { LogoLoader } from '../../../../../common/components/LogoLoader/LogoLoader'
import { PREDEFINED_TAG_NAMES } from '../../../data/vault-store'

export const TagsDropdown = observer(({ selectedTags = [], onTagSelect }) => {
    const { vaultStore } = useStore()
    const [searchTerm, setSearchTerm] = useState('')

    const isTagSelected = (tag) => {
        return selectedTags.some(selectedTag =>
            selectedTag.id === tag.id || selectedTag.tag === tag.name
        )
    }

    const filteredTags = useMemo(() => {
        const allTags = [
            ...(vaultStore.predefinedTags || []),
            ...(vaultStore.customTags || [])
        ]

        // Filter by search term and sort alphabetically
        return allTags
            .filter(tag => {
                const tagName = tag.name || tag.label || tag.id || ''
                return tagName.toLowerCase().includes(searchTerm.toLowerCase())
            })
            .sort((a, b) => {
                const aName = (PREDEFINED_TAG_NAMES[a.id] || a.name || a.label || a.id || '').toLowerCase()
                const bName = (PREDEFINED_TAG_NAMES[b.id] || b.name || b.label || b.id || '').toLowerCase()
                return aName.localeCompare(bName)
            })
    }, [vaultStore.predefinedTags, vaultStore.customTags, searchTerm])

    const handleTagClick = (tag) => {
        onTagSelect(tag)
    }

    const handleSearchChange = (e) => {
        setSearchTerm(e.target.value)
    }

    const handleCheckboxChange = (e, tag) => {
        e.stopPropagation()
        handleTagClick(tag)
    }

    if (vaultStore.isLoadingTags) {
        return (
            <TagsDropdownContainer>
                <div style={{ padding: '16px', display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100px' }}>
                    <LogoLoader />
                </div>
            </TagsDropdownContainer>
        )
    }

    return (
        <TagsDropdownContainer onClick={(e) => e.stopPropagation()}>
            <TagsDropdownHeader>
                <DropdownSearch
                    placeholder="Search tags"
                    value={searchTerm}
                    onChange={handleSearchChange}
                />
            </TagsDropdownHeader>

            <TagsDropdownBody id="tags-dropdown-body">
                {filteredTags.length > 0 ? (
                    filteredTags.map((tag) => (
                        <TagOption
                            key={tag.id}
                            onClick={() => handleTagClick(tag)}
                        >
                            <TagCheckbox>
                                <input
                                    type="checkbox"
                                    checked={isTagSelected(tag)}
                                    onChange={(e) => handleCheckboxChange(e, tag)}
                                />
                                <span className="checkmark">
                                    {isTagSelected(tag) ? <CheckboxCheckmarkIcon /> : null}
                                </span>
                            </TagCheckbox>
                            <TagIcon>
                                <SmartTagIcon tagName={tag.id || tag.tag || tag.name} />
                            </TagIcon>
                            <TagLabel>{PREDEFINED_TAG_NAMES[tag.id] || tag.name || tag.label || tag.id}</TagLabel>
                        </TagOption>
                    ))
                ) : searchTerm ? (
                    <div style={{ padding: '16px', textAlign: 'center', color: '#999' }}>
                        No tags found matching "{searchTerm}"
                    </div>
                ) : null}
            </TagsDropdownBody>
        </TagsDropdownContainer>
    )
})